import learnActions from './learnActions.js';

function experience(backendAxiosInstance) {
  return {
    ...learnActions(backendAxiosInstance)
  };
}

export { experience as default };
//# sourceMappingURL=index.js.map
